import React from 'react';
import { Group, Text, Pagination, Box } from '@mantine/core';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    totalResults: number;
    onPageChange: (page: number) => void;
    itemsPerPage?: number;
    showPageInfo?: boolean;
    size?: 'sm' | 'md' | 'lg';
    showFirstLastButtons?: boolean;
}

export const CommonPagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    totalResults,
    onPageChange,
    itemsPerPage = 25,
    showPageInfo = true,
    size = 'sm',
    showFirstLastButtons = true
}) => {
    if (totalPages <= 1) {
        return null;
    }

    const handlePageChange = (page: number) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        onPageChange(page);
    };

    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalResults);

    return (
        <Box className="hades-pagination-bar">
            {showPageInfo && (
                <Text className="hades-pagination-range">
                    {startItem.toLocaleString()}–{endItem.toLocaleString()}
                    <Text span c="dimmed" inherit> of </Text>
                    {totalResults.toLocaleString()}
                </Text>
            )}

            <Box className="hades-pagination-controls">
                <Pagination
                    total={totalPages}
                    value={currentPage}
                    onChange={handlePageChange}
                    withEdges={showFirstLastButtons}
                    size={size}
                    radius="sm"
                />
            </Box>

            {showPageInfo && (
                <Text className="hades-pagination-page">
                    Page {currentPage.toLocaleString()}
                    <Text span c="dimmed" inherit> of </Text>
                    {totalPages.toLocaleString()}
                </Text>
            )}
        </Box>
    );
};
